import { ReactElement } from 'react';
import { DownloadButton } from 'components';
import { useFiancePeriod } from '../useFinancePeriod';

export function Export({ url }: { url: string }): ReactElement {
  const financePeriod = useFiancePeriod();

  return (
    <DownloadButton
      url={`${url}candidates/`}
      icon="file-excel"
      variant="secondary"
      size="sm"
      className="ml-3"
      accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
      queryParams={{ finance_period: financePeriod ? `${financePeriod.start},${financePeriod.end}` : '' }}
    >
      Export linkable
    </DownloadButton>
  );
}
